export const HELP_CATEGORY_SLUG_REDIRECTS = {
  registraciya: 'registration',
  'depozity-i-vyplaty': 'deposits-withdrawals',
  'lichnye-dannye': 'personal-data',
  stavki: 'bets',
  'akcii-i-bonusy': 'promotions-bonuses',
  'tehnicheskie-voprosy': 'technical-support',
};

export const HELP_QUESTION_SLUG_REDIRECTS = {
  'kak-zaregistrirovatsya-id1249': 'how-to-register',
  'kak-proiti-identifikaciu-id471': 'how-to-verify',
  'zachem-prohodit-identifikaciu-id472': 'why-verification-required',
  'mozhno-li-registrirovatsya-po-voditelskomu-id473': 'register-with-driving-licence',
  'kakov-minimalnyi-vozrast-id474': 'minimum-age',
  'skolko-akkauntov-mozhno-imеть-id475': 'how-many-accounts',
  'kak-popolnit-schet-id501': 'how-to-deposit',
  'kak-vyvesti-vyigrysh-id502': 'how-to-withdraw',
  'kakie-limity-id503': 'deposit-withdrawal-limits',
  'kak-vosstanovit-parol-id601': 'recover-password',
  'kak-izmenit-email-id602': 'change-email',
  'kak-obnovit-pasport-id603': 'update-id-documents',
  'minimalnaya-stavka-id701': 'minimum-bet',
  'live-i-prematch-id702': 'live-vs-prematch',
  'otmenennoe-sobytie-id703': 'cancelled-event',
  'promokod-id801': 'promo-code',
  'freebet-id802': 'free-bet',
  'support-id901': 'contact-support',
  'zapros-id902': 'submit-support-request',
  'email-id903': 'marketing-emails',
};

export const HELP_INSTRUCTION_CATEGORY_SLUG_REDIRECTS = {
  'ustanovka-prilojenii': 'app-installation',
  'nastroika-interfeisa': 'interface-settings',
};

export const HELP_INSTRUCTION_ARTICLE_SLUG_REDIRECTS = {
  'ios-ustanovka': 'ios-installation',
  'android-ustanovka': 'android-installation',
};

export const HELP_TRAINING_CATEGORY_SLUG_REDIRECTS = {
  'strategii-stavok': 'betting-strategies',
  'sovety-dlya-novichka': 'beginner-tips',
};

export const HELP_GLOSSARY_SLUG_REDIRECTS = {
  'aziatskaya-fora-2-id1248': 'asian-handicap',
  'aziatskii-total-id1917': 'asian-total',
  'european-handicup-id1922': 'european-handicap',
  'autform-id381': 'away-form',
  'autrait-id379': 'away',
  'autsaider-id380': 'away-team',
  'dogovornoi-match-id392': 'fixed-match',
  'vilka-id385': 'arbitrage',
  'vilochnik-id386': 'arbitrage-bettor',
  'apset-id378': 'upset',
  'bankroll-bank-id382': 'bankroll',
  'bukmeker-id384': 'bookmaker',
  'liniya-id397': 'betting-line',
  'rospis-id401': 'betting-schedule',
  'prodaja-stavki-id399': 'cash-out',
  'veidjer-id839': 'wager',
  'fribet-id2054': 'free-bet',
  'bigmarket-id782': 'big-market',
  'dvoinoi-ishod-id390': 'double-chance',
  'laiv-id396': 'live-betting',
  'strategiya-dallasa-id820': 'dallas-strategy',
  'strategiya-dalambera-id790': 'd-alembert-strategy',
  'gandikap-id388': 'handicap',
  'fora-2-id1247': 'handicap-fora',
  'gollandskaya-sistema-id389': 'dutch-system',
  'vozvrat-rashod-id387': 'push-refund',
  'insaid-id393': 'inside-information',
  'skandinavskaya-nichya-id530': 'scandinavian-draw',
  'ekspress-2-id1256': 'accumulator',
  'koridor-id809': 'corridor',
  'obe-zabut-id810': 'both-teams-to-score',
  'kapper-id395': 'tipster',
  'kupon-id423': 'bet-slip',
  'snyatyi-match-id402': 'removed-event',
  'smolmarket-id786': 'small-market',
  'marja-id488': 'margin',
  'match-centr-id424': 'match-centre',
  'lesenka-id816': 'ladder-system',
  'strategiya-martingeil-id835': 'martingale-strategy',
  'osnovnoe-vremya-id778': 'regular-time',
  'koefficient-2-id1246': 'odds',
  'strategiya-oskara-grainda-id794': 'oscar-grind-strategy',
  'rashod-id400': 'push',
  'flet-id484': 'flat-betting',
  'sistema-2-id1245': 'system-bet',
  'ishod-id394': 'outcome',
  'taim-match-id403': 'time-period-bet',
  'dopolnitelnoe-vremya-id1921': 'extra-time',
  'va-bank-id1920': 'all-in',
  'chet-nechet-id756': 'odd-even',
  'odinar-id433': 'single-bet',
  'dogon-id483': 'chasing-losses',
  'individualnyi-total-2-id1923': 'team-total',
  'total-id404': 'total-goals',
  'xg-2-id1257': 'expected-goals-xg',
  'gorizontalnyi-ekspress-id490': 'same-game-accumulator',
};

function resolveSlug(slug, redirects) {
  if (!slug) return slug;
  return redirects[slug] || slug;
}

export function resolveHelpCategorySlug(slug) {
  return resolveSlug(slug, HELP_CATEGORY_SLUG_REDIRECTS);
}

export function resolveHelpQuestionSlug(slug) {
  return resolveSlug(slug, HELP_QUESTION_SLUG_REDIRECTS);
}

export function resolveInstructionCategorySlug(slug) {
  return resolveSlug(slug, HELP_INSTRUCTION_CATEGORY_SLUG_REDIRECTS);
}

export function resolveInstructionArticleSlug(slug) {
  return resolveSlug(slug, HELP_INSTRUCTION_ARTICLE_SLUG_REDIRECTS);
}

export function resolveTrainingCategorySlug(slug) {
  return resolveSlug(slug, HELP_TRAINING_CATEGORY_SLUG_REDIRECTS);
}

export function resolveGlossarySlug(slug) {
  return resolveSlug(slug, HELP_GLOSSARY_SLUG_REDIRECTS);
}
